import { UserV10 } from './v10/user/model/userV10';
import { UserV11 } from './v11/user/model/userV11';
export class UserTransformer {
    static transform(inVersion, outVersion, payload) {
        const transformation = inVersion + '-to-' + outVersion;
        switch (transformation) {
            case '12-to-11':
                return UserV11.constructFromPlainObject(payload);
            case '12-to-10':
                return UserV10.constructFromPlainObject(payload);
            default:
                throw new Error('Unsupported transformation: ' + transformation);
        }
    }
}
//# sourceMappingURL=userTransformer.js.map